// extracted by mini-css-extract-plugin
module.exports = {"Cell":"Cell_Cell__3UG7I","thickBorder":"Cell_thickBorder__2PBVu"};